import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { loadUmami } from './app/core/analytics/umami';

loadUmami(environment.umamiWebsiteId);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
